export const error = {
  en: {
    // 404 page — random copy variant 1 ("WHOOPS" pair).
    notFoundWhoopsTitle: "WHOOPS! 404 ERROR.",
    notFoundWhoopsText: "YOU'RE ALONE IN THE WOODS.",
    // 404 page — random copy variant 2 ("DANG" pair).
    notFoundDangTitle: "DANG. 404 ERROR.",
    notFoundDangText:
      "If a BÆR roars and no one hears it, did it make a sound?",
    // 404 CTA. {siteName} = brand/site name, passed through verbatim.
    notFoundCta: "Take me back to {siteName}",
    // Error boundary page (error.tsx).
    errorHeading: "Something went wrong",
    errorBody: "We encountered an unexpected error. Please try again.",
    errorRetryAria: "Try loading the page again",
    errorRetry: "Try again",
    // Post-purchase segment boundaries (no-header / upsell). Deliberately
    // distinct from errorHeading so it does not imply the payment failed —
    // the buyer has already paid by the time these routes render (DEV-9909).
    errorPageNotLoaded: "This page didn't load",
    // Account-area segment boundary (account/(shell)/error.tsx).
    accountErrorHeading: "We couldn't load your account",
  },
  de: {
    notFoundWhoopsTitle: "HOPPLA! 404-FEHLER.",
    notFoundWhoopsText: "DU BIST ALLEIN IM WALD.",
    notFoundDangTitle: "MIST. 404-FEHLER.",
    notFoundDangText:
      "Wenn ein BÆR brüllt und niemand es hört, hat er dann ein Geräusch gemacht?",
    notFoundCta: "Zurück zu {siteName}",
    errorHeading: "Etwas ist schiefgelaufen",
    errorBody:
      "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuche es erneut.",
    errorRetryAria: "Versuche, die Seite erneut zu laden",
    errorRetry: "Erneut versuchen",
    errorPageNotLoaded: "Diese Seite konnte nicht geladen werden",
    accountErrorHeading: "Wir konnten dein Konto nicht laden",
  },
} as const
